import { createContext, createElement, useContext, } from 'react';
export const ReactLinkContext = createContext({
    Link: ({ children, to, ...props }) => {
        return createElement('a', { href: to, ...props }, children);
    },
});
export function useReactLinkHandler() {
    return useContext(ReactLinkContext);
}
export function useLink() {
    return useReactLinkHandler().Link;
}
//# sourceMappingURL=react-link.js.map